import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import BackButton from '../../components/BackButton';

const ChangePassword = () => {
  const navigate = useNavigate();

  const initialFormData = {
    CurrentPassword: '',
    NewPassword: '',
    ConfirmNewPassword: '',  // Add ConfirmNewPassword field
    BUId: sessionStorage.getItem("BUId"), // Add BUId directly to the formData
  };

  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleCustomRedirect = () => {
    navigate('/Dashboard');
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.CurrentPassword.trim()) {
      newErrors.CurrentPassword = 'Current Password is required';
    }

    if (!formData.NewPassword.trim()) {
      newErrors.NewPassword = 'New Password is required';
    }

    // Confirm Password validation
    if (formData.NewPassword !== formData.ConfirmNewPassword) {
      newErrors.ConfirmNewPassword = 'New Password and Confirm New Password must match';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('Form submit triggered');

    const newErrors = validateForm();
    console.log('Validation Errors:', newErrors); // Log errors

    if (Object.keys(newErrors).length === 0) {
      console.log('Form is valid, submitting...');
      setLoading(true);

      console.log('Submitting form data:', formData);

      try {
        const url = `${process.env.REACT_APP_API_URL}/Login/ChangePassword`; 

        const response = await fetch(url, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData), 
        });

        console.log('API Response:', response); 

        const data = await response.json();
        console.log('API Data:', data); 

        if (data) {
          alert(`${data.response.result} `);
          // Clear the form data after successful save
          setFormData(initialFormData); // Reset the form data to initial values
          navigate("/ChangePassword"); 
        } else {
          throw new Error(data.message || 'An error occurred');
        }
      } catch (error) {
        console.error('Error:', error);
        alert(error.message || 'An error occurred. Please try again.');
      } finally {
        setLoading(false);
      }
    } else {
      setErrors(newErrors);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:px-6 lg:px-8">
      <BackButton label="Back" onClickRedirect={handleCustomRedirect} />

      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">CHANGE PASSWORD</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6 bg-white p-8 rounded-lg shadow">
          {/* Current Password */}
          <div>
            <label htmlFor="CurrentPassword" className="block text-sm font-medium text-gray-700">
              Current Password
            </label>
            <input 
              type="password"
              name="CurrentPassword"
              id="CurrentPassword"
              value={formData.CurrentPassword}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border ${errors.CurrentPassword ? 'border-red-300' : 'border-gray-300'} px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500 `}
            />
            {errors.CurrentPassword && (
              <p className="mt-1 text-sm text-red-600">{errors.CurrentPassword}</p>
            )}
          </div>

          {/* New Password */}
          <div>
            <label htmlFor="NewPassword" className="block text-sm font-medium text-gray-700">
              New Password
            </label>
            <input
              type="password"
              name="NewPassword"
              id="NewPassword"
              value={formData.NewPassword}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border ${errors.NewPassword ? 'border-red-300' : 'border-gray-300'} px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500`}
            />
            {errors.NewPassword && (
              <p className="mt-1 text-sm text-red-600">{errors.NewPassword}</p>
            )}
          </div>

          {/* Confirm New Password */}
          <div>
            <label htmlFor="ConfirmNewPassword" className="block text-sm font-medium text-gray-700">
              Confirm New Password
            </label>
            <input
              type="password"
              name="ConfirmNewPassword"
              id="ConfirmNewPassword"
              value={formData.ConfirmNewPassword}
              onChange={handleChange}
              className={`mt-1 block w-full rounded-md border ${errors.ConfirmNewPassword ? 'border-red-300' : 'border-gray-300'} px-3 py-2 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500`}
            />
            {errors.ConfirmNewPassword && (
              <p className="mt-1 text-sm text-red-600">{errors.ConfirmNewPassword}</p>
            )}
          </div>

          <div className="flex justify-end">
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg transition-colors disabled:opacity-50"
              disabled={loading}
            >
              {loading ? 'Saving...' : 'UPDATE PASSWORD'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
